export default () => {
  (function (stb) {
    'use strict';
  
    const dom = {
      stb: null,
      stbItemList: null,
      stbItems: [],
      firstStbItems: null,
      lastStbItems: null,
      targets: [],
    };
  
    const cacheDom = () => {
      dom.stb = document.querySelector('#scroll-to-bar');
      dom.stbItemList = dom.stb.querySelector('.stb__item-list');
      dom.stbItems = Array.from(dom.stbItemList.querySelectorAll('.stb__item'));
      dom.targets = dom.stbItems
        .filter(elem => elem.dataset.targetId && document.querySelector(elem.dataset.targetId))
        .map(elem => [elem, document.querySelector(elem.dataset.targetId)]);
      dom.firstStbItems = dom.targets.length > 0 ? dom.targets[0][0] : null;
      dom.lastStbItems = dom.targets.length > 0 ? dom.targets[dom.targets.length - 1][0] : null;
    };
  
    const bindUIActions = () => {
      if (dom.targets.length === 0) return;
  
      const visibleStbItems = dom.stbItems.filter(elem => {
        const isVisible = document.querySelector(elem.dataset.targetId);
        elem.classList.toggle('is-invisible', !isVisible);
        elem.classList.toggle('is-hidden', !isVisible);
        return isVisible;
      });
  
      dom.firstStbItems = visibleStbItems.length > 0 ? visibleStbItems[0] : null;
      dom.lastStbItems = visibleStbItems.length > 0 ? visibleStbItems[visibleStbItems.length - 1] : null;
  
      window.addEventListener('scroll', handleScroll);
      showScrollToBarOnDesktop();
    };
  
    const handleScroll = () => {
      const headerHeight = window.innerWidth < 1024 ? 70 : 102;
      const stbHeight = dom.stb.getBoundingClientRect().height;
      const padding = 16;
      const topSectionHeight = parseInt(headerHeight) + stbHeight + padding;
  
      const selected = dom.targets.find(([subnavItemElem, targetElem]) => {
        const { top, bottom } = targetElem.getBoundingClientRect();
        return top < topSectionHeight && bottom > topSectionHeight;
      });
  
      if (selected) {
        const selectedStbItemElem = selected[0];
        if (selectedStbItemElem.classList.contains('is-selected')) return;
  
        dom.stbItems.forEach(elem => {
          elem.classList.remove('is-selected');
        });
  
        selectedStbItemElem.classList.add('is-selected');
        const selectedElemOffset = selectedStbItemElem.getBoundingClientRect().left - dom.stbItemList.getBoundingClientRect().left;
        dom.stbItemList.scrollBy({ left: selectedElemOffset - 16, behavior: 'smooth' });
      }
    };
  
    const showScrollToBarOnDesktop = () => {
      const targetEl = document.querySelector('#product-main');
      const stb = document.querySelector('#scroll-to-bar');
  
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const { isIntersecting } = entry;
            if (isIntersecting) {
              stb.classList.remove('stb__visible');
            } else {
              stb.classList.add('stb__visible');
            }
          });
        },
        { rootMargin: '100px', threshold: 0.2 }
      );
  
      observer.observe(targetEl);
    };
  
    const init = () => {
      cacheDom();
      bindUIActions();
    };
  
    stb.init = init;
  })((window.stb = window.stb || {}));
}